import React,{useState, useEffect, useRef} from 'react'
import {makeStyles} from '@material-ui/core/styles'
import styled from 'styled-components'
import {toast} from 'react-toastify'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'
# import isMobile from 'is-mobile'
import contactPoints from '../../card/contact-points'
import {getConfig, getPlaceholder, getLabel, getHref, getValue, getFieldType, getSimilarValue} from '../../card/contact-points'

EditPopup = (props)->
	{point, handlePointEdit, handlePointRemove} = props

	<Popup
		{props...}
		popupType="edit"
		title="Edit contact point"
		confirmLabel="Edit Point"
		confirmAction={(newPoint)-> handlePointEdit(point, newPoint)}
		removeAction={()-> handlePointRemove(point)}
		baseValues={point or {type:'', value:''}}
		showRemove={true}
	/>

AddPopup = (props)->
	{handlePointAdd} = props

	<Popup
		{props...}
		popupType="add"
		title="Add a contact point"
		confirmLabel="Add Point"
		confirmAction={handlePointAdd}
		baseValues={{type:'', value:''}}
	/>

Popup = (props)->
	{open, points, closePopup} = props
	[values, setValues] = useState(props.baseValues)
	[errors, setErrors] = useState({type:false, value:false})
	[labelWidth, setLabelWidth] = useState(0)
	classes = useStyles()
	inputLabel = React.useRef(null)
	# mobile = isMobile(tablet:true)

	if values.type and not values.value
		similarValue = getSimilarValue(values.type, points)
		setValues({values..., value:similarValue}) if similarValue

	useEffect(()->
		setValues(props.baseValues)
	,[props.baseValues])
	
	useEffect(()->
		setErrors({type:false, value:false})
	,[values])
	
	useEffect(()->
		setLabelWidth(inputLabel.current?.offsetWidth)
	,[!open])

	_setErrors = (newErrors)->
		setErrors {errors..., newErrors...}
	
	handleClose = ()->
		closePopup(props.popupType)
	
	handleAdd = ()->
		if validate(values, _setErrors)
			handleClose()
			props.confirmAction(preparePointOutput(values))
	
	handleChange = (prop)-> (event)->
		setValues {values..., [prop]:event.target.value}
	
	<Dialog open={open} onClose={handleClose} maxWidth="sm">
		<DialogTitle>{props.title}</DialogTitle>
		
		<DialogContent dividers>
			<FormControl className={classes.selectWrap} variant="outlined" error={errors.type}>
				<InputLabel ref={inputLabel} id="Popup-type-select">{"Connection Type"}</InputLabel>
				<Select
					native={true}
					className={classes.select}
					labelId="Popup-type-select"
					labelWidth={labelWidth or 120}
					name="type"
					value={values.type}
					onChange={handleChange('type')}
				>
					<option value=""></option>
					{contactPoints.map (point, i)->
						<option key={i} value={point.type}>{point.label}</option>
					}
				</Select>
			</FormControl>
			
			{if values.type
				<TextField
					variant="outlined"
					name="value"
					className={classes.field}
					type={getFieldType(values.type) or 'text'}
					label={getPlaceholder(values.type) or 'Value'}
					value={values.value}
					onChange={handleChange('value')}
					error={errors.value}
					disabled={!values.type}
					fullWidth
				/>
			}
			<Clearfix />
		</DialogContent>

		<DialogActions>
			{if props.showRemove
				<IconButton onClick={props.removeAction} color="secondary">
					<DeleteIcon />
				</IconButton>
			}
			<Button color="primary" onClick={handleClose}>{"Cancel"}</Button>
			<Button color="primary" onClick={handleAdd}>{props.confirmLabel}</Button>
		</DialogActions>
	</Dialog>



validate = (values, setErrors)->
	valid = true
	errors = {}
	
	if not values.type
		errors.type = true
		valid = false
	
	if not values.value
		errors.value = true
		valid = false
	
	config = getConfig(values.type)
	if config?.validate
		isValidValue = config.validate(values.value)
		if isValidValue isnt true
			toast.error(isValidValue) if typeof isValidValue is 'string'
			errors.value = true
			valid = false
	
	if not valid
		setErrors(errors)
	
	return valid


preparePointOutput = (values)->
	extra =
		label: getLabel(values.type)
		href: getHref(values.type, values.value)
		value: getValue(values.type, values.value)
	
	return {values..., extra...}


Clearfix = styled.div"""
	min-width: 263px
"""


useStyles = makeStyles
	selectWrap:
		width: '100%'
		margin: '10px auto'
	select:
		'& select:focus':
			background: 'transparent'
	field:
		margin: '10px auto'

export {AddPopup, EditPopup}